import React from 'react'

const Row=({children})=>
{
    const Items=children.length;
    const Porcentaje = 100 / Items;
    var Largo="";
    Array.from({length:Items}).map(() => Largo+=`${Porcentaje}% `);
    
    return <div style={{display: "grid",gridTemplateRows: Largo,alignItems: "center"}}>
        {children}
    </div>
}
export default Row;